import supabaseClient from '@/api/supabaseClient.ts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { FunctionsHttpError } from '@supabase/supabase-js';
import { BackendErrorResponse } from '@/types/response/BackendErrorResponse';

type AdminUpdateCarerProfileParams = {
  user_id: string;
  bio?: string;
  hourly_rate?: number;
  service_area?: string;
  care_types?: string[];
  skills?: string[];
};

const useAdminUpdateCarerProfile = () => {
  const queryClient = useQueryClient();

  const mutationFn = async (params: AdminUpdateCarerProfileParams) => {
    const { data, error } = await supabaseClient.functions.invoke('admin_update_carer_profile', {
      method: 'POST',
      body: params,
    });

    if (error) {
      if (error instanceof FunctionsHttpError) {
        const err: BackendErrorResponse = await error.context.json();
        throw new Error(err.errors.join(', '));
      }
      throw new Error((error as Error).message);
    }

    return data;
  };

  return useMutation({
    mutationFn,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['admin-carer-onboarding', variables.user_id] });
      queryClient.invalidateQueries({ queryKey: ['admin-carers'] });
    },
  });
};

export default useAdminUpdateCarerProfile;
